import { getDefaultLogger } from '../logger/logger'

declare global {
  interface Window {
    UC_UI?: UC_Utility
  }
}
interface ServiceInfo {
  consent: {
    history: Array<unknown>
    status: boolean
  }
  id: string
  name: string
}
interface UC_Utility {
  isInitialized: () => boolean
  // don't know if null is possible, but in the original code was code to handle it that's why I added the | undefined
  getServicesFullInfo: () => Promise<Array<ServiceInfo>> | undefined
}

const dataDogServiceId = 'Xl0HIOViY'

const waitForUC_UI = (maxRetries = 20, intervalMs = 300): Promise<void> =>
  new Promise((resolve, reject) => {
    let attempts = 0
    const intervalId = setInterval(() => {
      const isInitialized = Boolean(window.UC_UI?.isInitialized?.())
      if (isInitialized) {
        clearInterval(intervalId)
        resolve()
      } else if (++attempts >= maxRetries) {
        clearInterval(intervalId)
        reject(Error('UC_UI initialization max retries exceeded in.'))
      }
    }, intervalMs)
  })

const getServicesFullInfo = async () => {
  try {
    await waitForUC_UI()
    return window.UC_UI?.getServicesFullInfo() ?? []
  } catch (error) {
    getDefaultLogger().info('Error in checking DataDog RUM consent', error)
    return []
  }
}

const isDataDogRumConsentAccepted = async () => {
  const allServices = await getServicesFullInfo()
  const dataDogService = allServices.find((service) => service.id === dataDogServiceId)
  return dataDogService?.consent?.status ?? false
}
export { waitForUC_UI, getServicesFullInfo, isDataDogRumConsentAccepted }
